import { AdditionalReferenceFormValues } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { AdditionalReferenceResponse, CreateOrUpdateAdditionalReferenceRequest } from '../../../../api/models'
import {
  AdditionalReferenceCreate,
  AdditionalReferenceUpdate,
  ParentTypeToRequestParentIdField,
} from './request'
import { AdditionalReference, AdditionalReferenceParentType } from './types'

export function fromAdditionalReferenceResponse(
  response: AdditionalReferenceResponse,
  parentType: AdditionalReferenceParentType,
  parentId: number,
  index: number,
): AdditionalReference {
  return {
    id: response.id,
    type: response.type ?? '',
    parentType,
    parentId,
    referenceNumber: response.referenceNumber ?? '',
    sequenceNumber: response.sequenceNumber ?? index,
  }
}

export function toAdditionalReferenceFormValues(additionalReference: AdditionalReference): AdditionalReferenceFormValues {
  return {
    id: additionalReference.id,
    sequenceNumber: additionalReference.sequenceNumber,
    type: additionalReference.type,
    referenceNumber: additionalReference.referenceNumber,
    deleted: false,
  }
}

export function toAdditionalReferenceCreate(
  transitOperationId: number,
  formValues: AdditionalReferenceFormValues,
): AdditionalReferenceCreate {
  return {
    transitOperationId,
    sequenceNumber: formValues.sequenceNumber,
    type: formValues.type,
    referenceNumber: formValues.referenceNumber,
  }
}

export function toAdditionalReferenceUpdate(
  transitOperationId: number,
  formValues: AdditionalReferenceFormValues,
): AdditionalReferenceUpdate {
  return {
    id: formValues.id,
    transitOperationId,
    sequenceNumber: formValues.sequenceNumber,
    type: formValues.type as AdditionalReferenceParentType,
    referenceNumber: formValues.referenceNumber,
  }
}

export function toCreateAdditionalReferenceRequest(
  parentId: number,
  parentType: AdditionalReferenceParentType,
  data: AdditionalReferenceCreate,
): CreateOrUpdateAdditionalReferenceRequest {
  const idReferenceField = ParentTypeToRequestParentIdField[parentType]

  return {
    transitOperationId: data.transitOperationId,
    sequenceNumber: data.sequenceNumber,
    type: data.type,
    referenceNumber: data.referenceNumber,
    [idReferenceField]: parentId,
  } as CreateOrUpdateAdditionalReferenceRequest
}

export function toUpdateAdditionalReferenceRequest(
  parentId: number,
  parentType: AdditionalReferenceParentType,
  data: AdditionalReferenceUpdate,
): CreateOrUpdateAdditionalReferenceRequest {
  const parentIdField = ParentTypeToRequestParentIdField[parentType]

  return {
    id: data.id,
    transitOperationId: data.transitOperationId,
    sequenceNumber: data.sequenceNumber,
    type: data.type,
    referenceNumber: data.referenceNumber,
    [parentIdField]: parentId,
  } as CreateOrUpdateAdditionalReferenceRequest
}
